// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** Ration Card Details Update Start ************************/
export const rationCardUpdateDetails = (updateRationCardData: any) => {
	const data = {
		RationCardDetailsToken: updateRationCardData,
	};
	const url = `${API_URL}updateRationCardDetails`;
	return makeApiCall(url, data);
};
/** ***************** Ration Card Details Update End ************************/
